import React, { useState } from 'react';
import { Text } from '@gjensidige/builders-components';
import { Delete, Edit } from '@gjensidige/builders-icons';
import { IPricingQuestion } from '../../interfaces/EnquiryInterface';
import { AdditionalInputs } from '../../interfaces/Types';
import { AppConstants } from '../../utils/AppConstants';
import { AddInputsModal } from './AddInputsModal';
import { DeleteConfirmationModal } from './DeleteConfirmationModal';

interface AddedInputsSection {
  item: AdditionalInputs;
  editIndex: number;
  additionalModalInputs: IPricingQuestion[];
  handleEditInputClick: (item: AdditionalInputs, key: number) => void;
  handleModalInputChange: (
    type: string,
    value: string,
    isValid?: boolean
  ) => void;
  updateAdditionalQuestions: (itemIndex: number) => void;
  deleteAdditionalQuestion: (itemIndex: number) => void;
}
export const AddedInputsSection: React.FC<AddedInputsSection> = (
  props: AddedInputsSection
) => {
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const onAddModalClose = () => {
    setIsAddOpen(false);
  };
  const onDeleteModalClose = () => {
    setIsDeleteOpen(!isDeleteOpen);
  };
  const primaryButtonAction = () => {
    props.deleteAdditionalQuestion(props.editIndex);
    setIsAddOpen(!isAddOpen);
  };
  const handleSubmit = () => {
    props.updateAdditionalQuestions(props.editIndex);
    setIsAddOpen(false);
  };
  const handleEdit = () => {
    props.handleEditInputClick(props.item, props.editIndex);
    setIsAddOpen(true);
  };
  const handleDelete = () => {
    props.deleteAdditionalQuestion(props.editIndex);
    setIsDeleteOpen(false);
  };
  const getDeleteConfirmationBody = () => {
    return (
      <Text size="body" className="pt-2">
        Är du säker på att du vill ta bort{' '}
        <span className="font-weight-medium">{props.item?.type?.label}</span>?
      </Text>
    );
  };
  return (
    <>
      <div className="added-inputs-section p-2 mb-2">
        <div className="added-inputs-details">
          <Text className="font-weight-medium mb-1">
            {props.item?.type?.label}
          </Text>
          <Text>{`Byggyta: ${props.item?.area?.label}`}</Text>
          <Text>{`Indraget vatten: ${props.item?.energyType?.label}`}</Text>
        </div>
        <div className="update-added-input">
          <Edit className="" color="#090C33" onClick={handleEdit} />
          <Delete className="" color="#090C33" onClick={onDeleteModalClose} />
        </div>
      </div>
      <AddInputsModal
        isOpen={isAddOpen}
        modalHeader={AppConstants.getAppText(
          'webshop.villa.editAdditionalBuildingLabel'
        )}
        criticalButtonLabel={AppConstants.getAppText(
          'webshop.villa.extraBuildingUpdateButtonLabel'
        )}
        primaryButonLabel={AppConstants.getAppText(
          'webshop.villa.extraBuildingDeleteButtonLabel'
        )}
        onInputChange={props.handleModalInputChange}
        onModalClose={onAddModalClose}
        primaryButtonAction={primaryButtonAction}
        additionalModalInputs={props.additionalModalInputs}
        criticalButtonAction={handleSubmit}
        closeBtnLabel="Avbryt att ändra byggnad"
        modalLabel="Ändra övrig byggnad"
      />
      <DeleteConfirmationModal
        isOpen={isDeleteOpen}
        modalHeader="Ta bort byggnad"
        modalBody={getDeleteConfirmationBody()}
        secondaryButtonLabel="Ta bort byggnad"
        onModalClose={onDeleteModalClose}
        secondaryButtonAction={handleDelete}
      />
    </>
  );
};
